import type { Asset } from '@elara/client-core/lib/asset';
import type { FilePicker, FilePickerOptions } from '@elara/client-core/lib/file-picker';

import { fileToAsset } from '@elara/client-core/lib/asset';

/**
 * Web `FilePicker` implementation (ELARA-692) driving a transient, hidden
 * `<input type=file>`. Centralises the programmatic file-dialog dance that was
 * duplicated across `ChatInputView` and `BookingDetailsDialog`, so those views
 * no longer hold `HTMLInputElement` refs of their own.
 *
 * This file is web-only and must not be imported by `@elara/mobile`; React
 * Native composes an `expo-image-picker`-backed `FilePicker` instead.
 */
export function createWebFilePicker(): FilePicker {
  return {
    async pick(options?: FilePickerOptions): Promise<Asset[]> {
      return new Promise((resolve) => {
        const input = document.createElement('input');
        input.type = 'file';
        if (options?.accept) input.accept = options.accept;
        input.multiple = options?.multiple ?? false;

        let settled = false;
        const settle = (assets: Asset[]) => {
          if (settled) return;
          settled = true;
          resolve(assets);
        };

        input.addEventListener('change', () => {
          settle([...(input.files ?? [])].map(fileToAsset));
        });
        // Fired when the dialog is dismissed without a selection (modern browsers).
        input.addEventListener('cancel', () => settle([]));

        input.click();
      });
    },
  };
}
